import React, { useEffect, useState } from 'react'
import InfoCantidadAdicional from './InfoCantidadAdicional'
import TableValueAction from '../../../MuiTable/components/TableValueAction'

function InfoAutodescargables (props) {
  const { productos, contenido, titulo = 'Camiones autodescargables' } = props
  const [total, setTotal] = useState(null)
  const [listado, setListado] = useState([])

  useEffect(() => {
    setTotal(productos.length)
    const camionesAutodescargables = []
    productos.map((camion) => {
      const { claveCereal, autodescargable } = camion
      const autodescargableExistente = camionesAutodescargables.find(c => c.cereal === claveCereal)
      if (autodescargable) {
        if (!autodescargableExistente) {
          camionesAutodescargables.push({ cereal: claveCereal, cantidad: 1 })
        } else {
          autodescargableExistente.cantidad += 1
        }
      }

      return camionesAutodescargables
    })

    setListado(camionesAutodescargables)
  }, [productos, setTotal])

  const shortcut = () => {
    return (
      <TableValueAction
        value={total}
        title={titulo}
        content={contenido()}
      />
    )
  }

  return (
    <>

      <InfoCantidadAdicional
        productos={listado}
        titulo='Autodescargables'
        cantidad={total}
        shortcut={shortcut}
      />
    </>
  )
}

export default InfoAutodescargables
